module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu4WxKOzY.c1e9793c.woff2";